import {Location, Loc} from './Location';

export type RotationDirection = 'clockwise' | 'counterclockwise';

// Positive angle is clockwise
export type WallPieceRotation = 0 | 90 | 180 | 270;

export class WallPiece {
    public constructor(public tiles: Loc[], public rotation: WallPieceRotation = 0) {
        // Only sets the instance variables
    }

    public rotate(direction: RotationDirection): void {
        const directions = {
            clockwise: (this.rotation + 90) % 360,
            counterclockwise: (this.rotation - 90 + 360) % 360,
        };
        this.rotation = directions[direction] as WallPieceRotation;
    }

    public rotatedLocations(base: Location): Location[] {
        return this.tiles.map(loc => {
            const [x, y] = new Map<WallPieceRotation, [number, number]>([
                [0, [loc.x, loc.y]],
                [90, [-loc.y, loc.x]],
                [180, [-loc.x, -loc.y]],
                [270, [loc.y, -loc.x]],
            ]).get(this.rotation) as [number, number];
            return base.offset(x, y);
        });
    }

    public toState(): Loc[] {
        return this.tiles;
    }
}



// WEBPACK FOOTER //
// ./src/common/map/WallPiece.ts